// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JobFiltersModal_root__TLyLB .JobFiltersModal_filters__6Pl65 .react-select__value-container {
  padding: 6px !important;
}
.JobFiltersModal_root__TLyLB .JobFiltersModal_filters__6Pl65 .chip {
  border-radius: 16px;
  border: solid 1px #dedede;
  background-color: white;
  padding: 2px 6px;
}
.JobFiltersModal_root__TLyLB .JobFiltersModal_footer__ADCJO {
  display: flex;
  justify-content: space-between;
  margin-top: 48px;
}`, "",{"version":3,"sources":["webpack://./src/components/organisms/JobFiltersModal/JobFiltersModal.module.scss"],"names":[],"mappings":"AAEI;EACE,uBAAA;AADN;AAII;EACE,mBAAA;EACA,yBAAA;EACA,uBAAA;EACA,gBAAA;AAFN;AAKE;EACE,aAAA;EACA,8BAAA;EACA,gBAAA;AAHJ","sourcesContent":[".root {\r\n  .filters {\r\n    :global(.react-select__value-container) {\r\n      padding: 6px !important;\r\n    }\r\n\r\n    :global(.chip) {\r\n      border-radius: 16px;\r\n      border: solid 1px #dedede;\r\n      background-color: white;\r\n      padding: 2px 6px;\r\n    }\r\n  }\r\n  .footer {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    margin-top: 48px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `JobFiltersModal_root__TLyLB`,
	"filters": `JobFiltersModal_filters__6Pl65`,
	"footer": `JobFiltersModal_footer__ADCJO`
};
export default ___CSS_LOADER_EXPORT___;
